import { AppReportEditItem, IAppReportEditItem } from "./appReportEditItem";
import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { AppReportEditUnitChange, IAppReportEditUnitChange } from "./appReportEditUnitChange";

export interface IAppReportEdit extends IAppReportEditUnitChange {
    item: IAppReportEditItem;
    units: IIdTitleNode[];
}

export class AppReportEdit extends AppReportEditUnitChange implements IAppReportEdit {
    item: AppReportEditItem;
    units: IdTitleNode[];

    constructor();
    constructor(obj: IAppReportEdit);
    constructor(obj?: any) {
        super(obj);
        this.item = new AppReportEditItem(obj ? obj.item : null);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
    }
}